import {
  BlockquoteProps as MantineBlockquoteProps,
  Blockquote as MantineBlockquote,
} from '@mantine/core';

export type BlockquoteProps = MantineBlockquoteProps;

export const Blockquote = MantineBlockquote;

Blockquote.displayName = 'Blockquote';
